import { motion } from "framer-motion";
import styled from "styled-components";
import { mediaMobile, mediaDesktop } from "utils/styles/responsive";
import { layout, colors } from "utils/styles/theme";

export const Wrapper = styled(motion.div)`
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: ${layout.zIndex.modals};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  user-select: none;
`;

export const ButtonStart = styled(motion.div)`
  margin-top: 200rem;
  height: 28rem;
  cursor: pointer;
  pointer-events: all;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  > svg {
    width: auto;
    height: 100%;
    margin: 0 15rem;
  }
  > img {
    width: auto;
    height: 150%;
    margin: 0 15rem;
  }

  ${mediaMobile(`
    margin-top: 110rem;
    height: 13rem;
    > svg {
      margin: 0 10rem;
    }
  `)}
`;

export const ButtonStartText = styled.p`
  font-family: FontLight;
  font-size: 16px;
  line-height: normal;
  letter-spacing: 2.56px;
  text-transform: uppercase;
  white-space: nowrap;
  margin-right: 30rem;
  color: ${colors.white};
  ${mediaMobile(`    
    margin-right: 15rem;
    font-size: 10rem;
    line-height: normal;
    letter-spacing: 1.92px;
    text-transform: uppercase;
  `)}
`;

export const SoundText = styled(motion.p)`
  width: 100%;
  font-family: FontRegular;
  font-size: 10rem;
  line-height: 1.2;
  opacity: 1;
  text-align: center;
  color: ${colors.white};

  ${mediaDesktop(`
    font-size: 18rem;
    margin: 44rem auto 0 auto;
  `)}
`;
